import { onMounted, onUnmounted } from 'vue'

export type Listener = [Document | Window, string, (e: any) => void, boolean?]
export interface ListenerArgs {
  target: any
  event: string
  callback: (e: MouseEvent) => void
  useCapture?: boolean
}

export function mountEventListener({ target, event, callback, useCapture }: ListenerArgs) {
  onMounted(() => target.addEventListener(event, callback, useCapture))
  onUnmounted(() => target.removeEventListener(event, callback))
}
export function mountEventListeners(listeners: Listener[]) {
  listeners.forEach(([target, event, callback, useCapture]) => {
    mountEventListener({ target, event, callback, useCapture })
  })
}

export function addEventListeners(listeners: Listener[]) {
  listeners.forEach(([target, event, callback, useCapture]) => {
    target.addEventListener(event, callback, useCapture)
  })
}
export function removeEventListeners(listeners: Listener[]) {
  listeners.forEach(([target, event, callback, useCapture]) => {
    target.removeEventListener(event, callback, useCapture)
  })
}
